/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */
import { fromJS } from 'immutable';
import Api from './api';

import {
  APP_CHANGE_FORM,
  APP_CLEAR_ERROR, APP_REQUEST_ERROR, APP_SENDING_REQUEST, APP_SET_AUTH, USER_LOGGEDIN,
  CATEGORIES_LOADED, PROJECTS_LOADED
} from './constants';

// The initial state of the App
const initialState = fromJS({
  user: {
    id: null,
    name: 'Guest',
  },
  hasChanges: false,
  projects: {},
  categories: [],
  tutorials: [],
  uploadProgress: 0,
  activeProject: null,
  activeProjectData: {},
  isUploading: false,
  formState: {
    username: null,
    password: null,
  },
  error: null,
  currentlySending: true,
  loggedIn: false,
  session_token: Api.checkTokenAvailable(),
  oauth_token: Api.getOauthToken(),
});

function appReducer(state = initialState, action) {
  /*
  if(window.dataLayer) {
    
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Actions',
      eventAction: action.type
    });
    
  }
  */

  switch (action.type) {
    case APP_CHANGE_FORM:
      return state.set('formState', fromJS(action.newFormState));
    case APP_SET_AUTH:
      return state.set('loggedIn', fromJS(action.newAuthState));
    case APP_SENDING_REQUEST:
      return state.set('currentlySending', fromJS(action.sending));
    case APP_REQUEST_ERROR:
      return state.set('error', fromJS(action.error));
    case APP_CLEAR_ERROR:
      return state.set('error', null);
    case USER_LOGGEDIN:
      return state
        .set('user', action.payload);

    case PROJECTS_LOADED:
      return state
        .set('projects', fromJS(action.payload.data.resource));
    case CATEGORIES_LOADED:
      return state
        .set('categories', fromJS(action.payload.data.resource));

    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducer.js